import LocationOverviewGlobalDevicesIpadsRoute from 'garaje/pods/location-overview/global-devices/ipads/route';

class LocationOverviewVirtualFrontDeskDevicesIpadsRoute extends LocationOverviewGlobalDevicesIpadsRoute {
  controllerName = 'location-overview/global-devices/ipads';
  templateName = 'location-overview/global-devices/ipads';
}

export default LocationOverviewVirtualFrontDeskDevicesIpadsRoute;
